import React from 'react';
import { CinematicScene } from '../CinematicScene';
import { Reveal } from '../Reveal';
import { imagery, pillars } from '../../data/site';
import { MotionMode } from '../../types/motion';
interface PhilosophySceneProps {
  motionMode?: MotionMode;
}
export function PhilosophyScene({
  motionMode = 'cinematic'
}: PhilosophySceneProps) {
  return <CinematicScene id="philosophy" image={imagery.space} imageAlt="The curated dining room with brass pendants glowing low over marble tables" motionMode={motionMode} scrim="center" data-id="element-111" data-mp="3m6gfa3wvjkl0">
      <div className="mx-auto flex h-full max-w-6xl flex-col justify-center px-6 py-24 text-center md:px-12" data-id="element-112" data-mp="3vzxbtfoebdsd">
        <Reveal data-id="element-113" data-mp="9qm8962667gj">
          <p className="mb-5 font-mono text-[10px] uppercase tracking-[0.3em] text-brass" data-id="element-114" data-mp="9pt7clpw6c6b">
            Our Philosophy
          </p>
        </Reveal>

        <Reveal delay={0.12} data-id="element-115" data-mp="2fjktjqfvrbrj">
          <h2 className="font-display text-3xl font-normal tracking-wide text-cream md:text-5xl" data-id="element-116" data-mp="2bhzb7pkku59y">
            THE PILLARS OF THE HOUSE
          </h2>
        </Reveal>

        <ul className="mt-12 grid gap-10 md:mt-16 md:grid-cols-3 md:gap-0" data-id="element-117" data-mp="1uqdlqeds48cs">
          {pillars.map((pillar, i) => <li key={pillar.title} className={`px-0 md:px-9 ${i > 0 ? 'border-t border-hair pt-10 md:border-l md:border-t-0 md:pt-0' : ''}`} data-id="element-118" data-mp="1zlaz1xi3d3vh" data-mpi={i}>
              <Reveal delay={0.25 + i * 0.14} data-id="element-119" data-mp="2ecths32c5cij">
                <span className="mb-5 block font-mono text-[10px] tracking-[0.25em] text-brass" data-id="element-120" data-mp="2ec08aubzs8wp">
                  {pillar.index} — {pillar.title}
                </span>
                <h3 className="mb-4 font-display text-xl tracking-[0.08em] text-cream md:text-2xl" data-id="element-121" data-mp="2ncyglotgr2l3">
                  {pillar.title}
                </h3>
                <p className="mx-auto max-w-xs font-mono text-[11.5px] leading-[1.85] text-stone md:text-xs" data-id="element-122" data-mp="2s9ymnzqbc5c7">
                  {pillar.body}
                </p>
              </Reveal>
            </li>)}
        </ul>
      </div>
    </CinematicScene>;
}